import { apiClient } from './client';

/**
 * Kreira porudžbinu. Cene se NE šalju — server ih računa iz baze,
 * pa iznos u korpi služi samo za prikaz.
 *
 * @param {object} payload
 * @param {object} payload.customer {fullName, phone, email, address, city, postalCode, note}
 * @param {Array<{productId: number, variantId: ?number, quantity: number}>} payload.items
 * @returns {Promise<{orderNumber, publicToken, status, paymentMethod, subtotal, shippingCost, total, items}>}
 */
export const createOrder = async ({ customer, items }) => {
  const { data } = await apiClient.post('/orders', {
    customer,
    items: items.map(({ productId, variantId, quantity }) => ({
      productId,
      variantId: variantId ?? null,
      quantity,
    })),
  });
  return data;
};

/**
 * Pregled porudžbine za stranicu uspeha. Token stiže u odgovoru na `createOrder` —
 * broj porudžbine sam po sebi ne otključava ništa.
 */
export const getOrder = async (orderNumber, token) => {
  const { data } = await apiClient.get(`/orders/${encodeURIComponent(orderNumber)}`, {
    params: { token },
  });
  return data;
};

export default { createOrder, getOrder };
